<template>
  <div>


  <h2 class="goth">Der-ord</h2>

  <div class="grammatikparagrafbredd leftorient">


    <p>Man kan <b>aldrig vara helt säker</b> på om ett tyskt substantiv är ett der-, das- eller die-ord och vilken plural det har
      genom att bara se på hur ordet ser ut eller vad det betyder. Men nedan kommer några av de <b>vanligaste
      reglerna</b> vad som kännetecknar ett der-ord och kan ge en <b>fingervisning</b> och stämmer i många fall</p>

<br>
<h4>der-ord är ofta...</h4>

    <div class="quasi-p"> &#x2022; Substantiv som betecknar personer av manligt kön
    </div>


    <div class="ruta">
    <p>
        <i>der Mann <br>mannen</i>
    </p>

    <p>
        <i>der Bruder <br>brodern</i>
    </p>

    <p>
        <i>der Schauspieler <br>skådespelaren</i>
    </p>

    <p>
        <i>der Arzt <br>[manliga] läkaren</i>
    </p>

    </div>

    <p class="mindre">Substantiv som betecknar yrken har i tyskan alltid en manlig och en kvinnlig version som är der- respektive
      die-ord</p>

    <br><br>


      <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-er</b>
      </div>


      <div class="ruta">
      <p>
          <i>der Staubsauger <br>dammsugaren</i>
      </p>
      </div>
    <br><br>



    <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-us, -or</b>
    </div>


    <div class="ruta">
    <p>
        <i>der Rhytmus <br>rytmen</i>
    </p>

    <p>
        <i>der Motor <br>motorn</i>
    </p>


    </div>
    <br><br>



    <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-ich, -ig</b>
    </div>


    <div class="ruta">
    <p>
        <i>der Teppich <br>mattan</i>
    </p>

    <p>
        <i>der Käfig <br>buren</i>
    </p>

    </div>
    <br><br>


    <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-e</b> och betecknar nationalitet
    </div>


    <div class="ruta">
    <p>
        <i>der Schwede <br>svensken</i>
    </p>
    <p>
        <i>der Däne <br>dansken</i>
    </p>
    </div>
    <p class="mindre">Maskulina ord som slutar på <b>-e</b> utgör en egen grupp kallad <i>jungegruppen</i> och
      har en grammatik som i vissa lägen avviker från övriga substantiv. Men det behöver man oftast inte tänka på i början</p>


    <h4>der-ord i plural</h4>
    <p>De flesta der-ord ofta <b>-e</b> i plural och ofta omljud d.v.s. <i>a</i> blir <i>ä</i>, <i>u</i> blir <i>ü</i>,
    <i>o</i> blir <i>ö</i> och <i>au</i> blir <i>äu</i>.</p>
    <p>Men der-ord (och das-ord) som slutar på <b>-en, -el</b> och <b>-er</b> får ingen plural ändelse (men kan ändå få omljud)</p>
    <p>Lånord får ofta <b>-s</b> i plural</p>




  </div>

  </div>




</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "ob wenn om huruvida"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
